import { render, staticRenderFns } from "./ReassignFlag.vue?vue&type=template&id=474e7343&scoped=true&"
import script from "./ReassignFlag.vue?vue&type=script&lang=ts&"
export * from "./ReassignFlag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474e7343",
  null
  
)

export default component.exports